import {Box, Button, Container, Typography} from "@mui/material"
import {useNavigate} from "react-router-dom"
import {Home} from "lucide-react"

export function NotFoundPage() {
  const navigate = useNavigate()
  
  return (
    <Container sx={{height: "70vh"}}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          gap: 4
        }}
      >
        <Typography variant="h1" sx={{fontSize: "6rem", fontWeight: "bold", color: "primary.main"}}>
          404
        </Typography>
        <Typography variant="h4" sx={{mb: 2}}>
          ページが見つかりませんでした
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{mb: 4}}>
          お探しのページは削除されたか、URLが間違っている可能性があります。
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<Home/>}
          onClick={() => navigate("/")}
        >
          ホームに戻る
        </Button>
      </Box>
    </Container>
  )
}